module.exports = __webpack_public_path__ + "img/taiwanpayIcon.abdf3f5f.jpg";